import { GetOnlineAccountResponse } from '@iwoca/lapi-client/edge';

type TOnlineSubaccount =
    GetOnlineAccountResponse['data'][number]['accounts'][number];

/**
 * Safely extracts the account number from an online subaccount's `extra`
 * field. The API types `extra` as an open `Record<string, unknown>`, so we
 * narrow the value at runtime rather than asserting its shape.
 */
export const getAccountNumber = (
    extra: TOnlineSubaccount['extra']
): string | undefined => {
    const accountNumber = extra?.account_number;
    return typeof accountNumber === 'string' ? accountNumber : undefined;
};
